@if (condition) {
  <div class="empty-node-editor">
  </div>
}